/**
 * @generated SignedSource<<47d2f547078e9a1f0c86ec69d077cedc>>
 * @relayHash 6acaba1311f7022f30ab8c9787bc7ece
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d20bda3fb3dd823e102fa586192a2364aa4ab6ef95eb1a7bdc350b6e582766fc

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SubspaceMenuListRefetchQuery$variables = {
  id: string;
};
export type SubspaceMenuListRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"SubspaceMenuList">;
  } | null | undefined;
};
export type SubspaceMenuListRefetchQuery = {
  response: SubspaceMenuListRefetchQuery$data;
  variables: SubspaceMenuListRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SubspaceMenuListRefetchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SubspaceMenuList"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubspaceMenuListRefetchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "concreteType": "JiraSubspaceConnection_CSE",
                    "kind": "LinkedField",
                    "name": "subspaces_cse",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraSubspaceEdge_CSE",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraSubspace_CSE",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "name"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "subspaceUrl"
                              },
                              (v2/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraProject"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d20bda3fb3dd823e102fa586192a2364aa4ab6ef95eb1a7bdc350b6e582766fc",
    "metadata": {},
    "name": "SubspaceMenuListRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7d5e77ba7979f7d2d1b9fc0310bed1a4";

export default node;
